module.exports = __webpack_public_path__ + "static/trusted-by-2d636a835f8f720346925d7a0ae9928f.png";